import { render, staticRenderFns } from "./addCreditNoteDialog.vue?vue&type=template&id=0b081177&scoped=true&"
import script from "./addCreditNoteDialog.vue?vue&type=script&lang=js&"
export * from "./addCreditNoteDialog.vue?vue&type=script&lang=js&"
import style0 from "./addCreditNoteDialog.vue?vue&type=style&index=0&id=0b081177&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b081177",
  null
  
)

export default component.exports